import { Button, Flex, FormControl, FormErrorMessage, FormLabel, HStack, Input, Stack, Text, useToast } from "@chakra-ui/react"
import { zodResolver } from "@hookform/resolvers/zod"
import { useFieldArray, useForm } from "react-hook-form"
import * as z from "zod"
import { useAppDispatch } from "src/redux/hooks"
import { useEffect, useState } from "react"
import { OneTranslateQuestion, updaateOneTranslateQuestion } from "src/view-models/Question"
import { useParams } from "react-router-dom"
import { RiLoader2Fill } from "react-icons/ri"

const formSchema = z.object({
    question: z.string().min(1, {
        message: "La question est obligatoire",
    }),
    answers: z.array(z.string()).nullable().optional()
})

type EditQuestionInputs = z.infer<typeof formSchema>

type Props = {
    data: any,
    isGeneratingAll: boolean
}

const TranslationForm = ({ data, isGeneratingAll }: Props) => {
    const { id } = useParams()
    const dispatch = useAppDispatch()
    const [isGenerating, setIsGenerating] = useState(false)
    const toast = useToast()
    //   const id = data?.question_id
    const { register, control, handleSubmit, setValue, formState: { errors, isSubmitting }, } = useForm<EditQuestionInputs>({
        resolver: zodResolver(formSchema),
        defaultValues: {
            question: data?.data?.question || "",
            answers: data?.data?.answers && data?.data?.answers?.length > 0 && data?.data?.answers?.map((a: any) => a?.answer) || undefined,
        }
    });

    const {
        fields,
    } = useFieldArray({
        control,
        //@ts-ignore
        name: "answers",
    });

    const onSubmit = async (values: z.infer<typeof formSchema>) => {
        const theValues = values?.answers ? { ...values, answers: data?.data?.answers?.map((answer: any, index: number) => ({ id: answer?.id, answer: values?.answers ? values.answers[index] : null })) } : values
        const response: any = await updaateOneTranslateQuestion(id!, data?.lng_id, theValues, toast, dispatch)
        if (response.status === true) {
        } else {
            return null
        }
    }

    const translateTheQuestion = async () => {
        setIsGenerating(true)
        const response: any = await OneTranslateQuestion(id!, data?.lng_id, dispatch)
        if (response.status === true) {
        } else {
        }
        setIsGenerating(false)
    }

    useEffect(() => {
        if (data) {
            setValue("question", data?.data?.question || "");
            setValue(
                "answers",
                data?.data?.answers && data?.data?.answers?.length > 0
                    ? data.data.answers.map((a: any) => a.answer)
                    : undefined
            );
        }
    }, [data, setValue]);

    return (
        <>
            <Text color='#4E5D78' fontWeight={700} fontSize={20} >Langue de {data?.lang_name}</Text>
            {isGenerating || isGeneratingAll ? (
                <Flex w='100%' h="100%" justifyContent='center' alignItems='center' pb={10} >
                    <RiLoader2Fill size={30} className='animate-spin' />
                </Flex>
            ) : (
                <form className="space-y-4 h-full overflow-y-auto py-4" onSubmit={handleSubmit(onSubmit)}>
                    <Flex flexDirection={"row"} gap={2} alignItems={"end"}>
                        <FormControl isRequired isInvalid={!!errors?.question}>
                            <FormLabel>Question</FormLabel>
                            <Input
                                boxShadow='sm'
                                disabled={isSubmitting}
                                rounded='5px'
                                type='text'
                                size='md'
                                id='question'
                                placeholder='question'
                                {...register("question")}
                            />

                            <FormErrorMessage>
                                {errors.question && errors?.question.message}
                            </FormErrorMessage>
                        </FormControl >
                        {data?.lang_code !== "fr" ? (
                            <HStack>
                                <Button
                                    type='submit'
                                    onClick={handleSubmit(onSubmit)}
                                    isLoading={isSubmitting}
                                    p='4'
                                    colorScheme='blue'
                                    variant='solid'
                                >
                                    Modifier
                                </Button>
                                <Button
                                    type='button'
                                    onClick={translateTheQuestion}
                                    isLoading={isSubmitting}
                                    p='4'
                                    colorScheme='blue'
                                    variant='solid'
                                >
                                    Traduire
                                </Button>
                            </HStack>
                        ) : null}
                    </Flex>
                    <Stack spacing={4}>
                        {fields.map((field, index) => (
                            <FormControl key={field.id} isInvalid={!!errors?.answers?.[index]}>
                                <FormLabel>Les reponses</FormLabel>
                                <Flex alignItems="center" gap={2}>
                                    <Input
                                        boxShadow="sm"
                                        disabled={isSubmitting}
                                        rounded="5px"
                                        type="text"
                                        size="md"
                                        placeholder="Answer translation"
                                        {...register(`answers.${index}`)}
                                        defaultValue={field.id} // Initialize with default value
                                    />

                                </Flex>
                                <FormErrorMessage>
                                    {errors.answers?.[index]?.message}
                                </FormErrorMessage>
                            </FormControl>
                        ))}
                    </Stack>
                </form >
            )}
        </>
    )
}

export default TranslationForm